import {
    Table,
    TableBody,
    TableHead,
    TableHeaderCell,
    TableCell,
    Heading,
    Paragraph,
    Button
} from "@digdir/designsystemet-react";
import { TerminSearchBlockProps } from "./types";

export function TerminSearchBlock(props: TerminSearchBlockProps) {
    const heading = props.translation.heading.replace("{numberofeventsdisplay}", (props.events?.length ?? 0).toString());

    return (
        <section className="w-full flex flex-col px-4 gap-4 my-10">
            {!props.hideSeeAll && (
                <header className="flex justify-between items-center">
                    <Heading level={2} className="!mb-0">{heading}</Heading>
                    {props.terminEventSearchPageUrl && (
                        <div className="md:block hidden">
                            <Button data-size="sm" variant="primary">
                                <a href={props.terminEventSearchPageUrl} className="text-white no-underline">
                                    <Paragraph data-size="sm"
                                               className="!mb-0">{props.translation.seeallevents}</Paragraph>
                                </a>
                            </Button>
                        </div>
                    )}
                </header>
            )}
            <div className="w-full hidden lg:block">
                <Table className="w-full">
                    <TableHead className="border-b-2 border-brand-detail-gray !text-left">
                        <TableHeaderCell className="px-3">{props.translation.table.from}</TableHeaderCell>
                        <TableHeaderCell className="px-3">{props.translation.table.to}</TableHeaderCell>
                        <TableHeaderCell className="px-3">{props.translation.table.eventname}</TableHeaderCell>
                        <TableHeaderCell className="px-3">{props.translation.table.host}</TableHeaderCell>
                        <TableHeaderCell className="px-3">{props.translation.table.activityname}</TableHeaderCell>
                        <TableHeaderCell className="px-3">{props.translation.table.countyname}</TableHeaderCell>
                    </TableHead>
                    <TableBody>
                        {props.events && props.events.length > 0 ? (
                            props.events.map((item) => (
                                <Table.Row className="border-b">
                                    <TableCell>{item.startDate}</TableCell>
                                    <TableCell>{item.endDate}</TableCell>
                                    <TableCell>
                                        <a href={item.eventUrl} className="text-primary no-underline">
                                            {item.eventName}
                                        </a>
                                    </TableCell>
                                    <TableCell>{item.arrangingOrgName}</TableCell>
                                    <TableCell>{item.activityName}</TableCell>
                                    <TableCell>{item.countyName}</TableCell>
                                </Table.Row>
                            ))
                        ) : (
                            <Table.Row>
                                <TableCell colSpan={6} className="w-full">
                                    <div className="w-full flex justify-center">
                                        <Paragraph data-size="sm" className="!mb-0">
                                            {props.translation.table.empty}
                                        </Paragraph>
                                    </div>
                                </TableCell>
                            </Table.Row>
                        )}
                    </TableBody>
                </Table>
            </div>
            <div className="lg:hidden">
                {props.events ? props.events.map((item) => (
                    <div className="flex flex-col gap-2 border-b hover:text-primary py-2">
                        <span><span
                            className="font-bold">{props.translation.table.from}: </span> {item.startDate}</span>
                        <span><span className="font-bold">{props.translation.table.to}: </span> {item.endDate}</span>
                        <span><span className="font-bold">{props.translation.table.eventname}: </span> <a
                            href={item.eventUrl}> <span>{item.eventName}</span></a></span>
                        <span><span
                            className="font-bold">{props.translation.table.host}: </span> {item.arrangingOrgName}</span>
                        <span><span
                            className="font-bold">{props.translation.table.activityname}: </span> {item.activityName}</span>
                        <span><span
                            className="font-bold">{props.translation.table.countyname}: </span> {item.countyName}</span>
                    </div>
                )) : (
                    <div className="flex flex-col gap-2 border-b hover:text-primary py-2">
                        <Paragraph className="!mb-0">
                            {props.translation.table.empty}
                        </Paragraph>
                    </div>
                )}
            </div>
            {!props.hideSeeAll && (
                <div className="lg:hidden">
                    <Button data-size="sm" variant="primary">
                        <a href={props.terminEventSearchPageUrl}
                           className="w-full flex justify-center text-white no-underline">
                            <Paragraph data-size="sm" className="!mb-0">{props.translation.seeallevents}</Paragraph>
                        </a>
                    </Button>
                </div>
            )}
        </section>

    )
} 